<template>
  <el-col :span="22" :offset="1">
    <el-tabs  style="min-width: 1100px;user-select: none" v-model="activeName" @tab-click="handleClick">
      <!-- 基本信息 -->
      <el-tab-pane :label="$t('p0203.basicInformation')" name="first">
        <p0204 ref="p0204"></p0204>
      </el-tab-pane>
      <!-- 人员信息 -->
      <el-tab-pane :label="$t('p0203.personnelInformation')" name="second"><p0205 ref="p0205"></p0205></el-tab-pane>
    </el-tabs>
  </el-col>
</template>
<script>
import p0204 from "../../views/CustomerInfoBase/P0204";
import p0205 from "../../views/CustomerInfoBase/P0205";
export default {
  name: "demo",
  components: {
    p0204,
    p0205
  },
  data() {
    return {
      activeName: sessionStorage.getItem('p0203First')
    };
  },
  methods: {
    handleClick(tab, event) {
      sessionStorage.p0203First=this.activeName
      console.log(tab, event);
    }
  }
};
</script>
<style lang="scss" scoped>
// >>> .el-tabs__item {
//   font-size: 16px;
// }
</style>



// WEBPACK FOOTER //
// src/views/CustomerInfoBase/P0203.vue